/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import usePaginationQueryParams from '../../hooks/usePaginationQueryParams'
import usePagination, { UsePaginationHook } from '../../hooks/usePagination'
import useQueryParams from '../../hooks/useQueryParams'

function usePaginationQuery (totalElements: number): UsePaginationHook {
  const [searchParams, setSearchParams] = useQueryParams()
  const { page: pageParam, limit: limitParam } = usePaginationQueryParams(searchParams)
  return usePagination({
    page: pageParam,
    limit: limitParam,
    totalElements,
    onChange (page: number, limit: number) {
      setSearchParams((s) => ({
        ...s,
        page: String(page),
        limit: String(limit)
      }))
    }
  })
}

export default usePaginationQuery
